import { DashboardModule, Form, Grid } from '@domain-group/suit-theme'

import type { AgencyModel } from '@models/types'

interface AgencyDetailsProps {
  agencySalesforceDetails: AgencyModel['salesforce_details'],
}

const AgencyDetails = (props: AgencyDetailsProps) => {
  const { agencySalesforceDetails } = props

  const agencyDetailsPayload = [
    { label: 'Title', value: agencySalesforceDetails?.title },
    { label: 'Active', value: agencySalesforceDetails?.active ? 'Active' : 'Inactive' },
    { label: 'Business Name', value: agencySalesforceDetails?.business_name },
    { label: 'Business Number', value: agencySalesforceDetails?.business_number },
    { label: 'License Number', value: agencySalesforceDetails?.license_number },
  ]

  return (
    <DashboardModule title="Agency Details">
      <Grid
        // @ts-expect-error TS2322
        gridGap="large"
        gridTemplateColumns={[
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(2, minmax(160px, 1fr))',
        ]}
        padding="large"
      >
        {agencyDetailsPayload.map(field => (
          <Form.Field label={field.label}>
            <input
              disabled
              type="text"
              value={field.value}
            />
          </Form.Field>
        ))}
      </Grid>
    </DashboardModule>
  )
}

export default AgencyDetails
